import { render, staticRenderFns } from "./RegisterItem.vue?vue&type=template&id=1f81bb2b&scoped=true&"
import script from "./RegisterItem.vue?vue&type=script&lang=js&"
export * from "./RegisterItem.vue?vue&type=script&lang=js&"
import style0 from "./RegisterItem.vue?vue&type=style&index=0&id=1f81bb2b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f81bb2b",
  null
  
)

export default component.exports